import { createAsyncThunk } from '@reduxjs/toolkit';

import { FormStepId } from 'shared/config/formStepId';

import { selectStepsFields } from 'entities/creditForm';
import { accountSelector } from 'entities/user/model/user.selectors';

import { sendCustomerDataThunk, type TSendCustomerDataThunkState } from 'features/SendCustomerData';

export const updateUserLandingDataThunk = createAsyncThunk<void, void, { state: TSendCustomerDataThunkState }>(
  'updateUserData/updateUserLandingDataThunk',
  async (_, { dispatch, getState }) => {
    const user = accountSelector(getState());

    if (!user) {
      return;
    }

    dispatch(
      sendCustomerDataThunk(selectStepsFields([FormStepId.CreditPurposeInfo, FormStepId.ContactsInfo])(getState())),
    );
  },
);
